import { GrantIdUpdateRow } from "../types/BulkGrantUpdate";

export interface PreviewRow extends GrantIdUpdateRow {
  isValid: boolean;
  errors: string[];
}

export function validateRows(rows: GrantIdUpdateRow[]): PreviewRow[] {
  const duplicateNewIdCount = new Map<string, number>();
  const duplicateOldIdCount = new Map<string, number>();

  rows.forEach((row) => {
    const oldId = (row.oldGrantId || "").trim().toUpperCase();
    const newId = (row.newGrantId || "").trim().toUpperCase();

    if (oldId) {
      duplicateOldIdCount.set(oldId, (duplicateOldIdCount.get(oldId) || 0) + 1);
    }
    if (newId) {
      duplicateNewIdCount.set(newId, (duplicateNewIdCount.get(newId) || 0) + 1);
    }
  });

  return rows.map((row, idx) => {
    const errors: string[] = [];
    const oldId = (row.oldGrantId || "").trim();
    const newId = (row.newGrantId || "").trim();
    const oldIdKey = oldId.toUpperCase();
    const newIdKey = newId.toUpperCase();

    if (!oldId) {
      errors.push("Old Grant Id is required");
    }

    if (!newId) {
      errors.push("New Grant Id is required");
    }

    if (oldId && newId && oldIdKey === newIdKey) {
      errors.push("Old Grant Id and New Grant Id cannot be the same");
    }

    if (oldId && (duplicateOldIdCount.get(oldIdKey) || 0) > 1) {
      errors.push("Duplicate Old Grant Id in payload");
    }

    if (newId && (duplicateNewIdCount.get(newIdKey) || 0) > 1) {
      errors.push("Duplicate New Grant Id in payload");
    }

    return {
      ...row,
      rowIndex: idx,
      isValid: errors.length === 0,
      errors,
    };
  });
}
